import type { TersaImageModel } from '../../types';
import { providers } from '../../../providers';
import { wavespeed } from '../../wavespeed';

// 系数
const COST_FACTOR = 1.5;

export const imagenModels: Record<string, TersaImageModel> = {
    'google/imagen4-ultra': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: wavespeed.image('google/imagen4-ultra'),
                getCost: () => {
                    return 0.058 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.058 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '1x1'],
                resolutions: ['1K', '2K'],
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i'],
        supportsEdit: false,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'google/imagen4': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: wavespeed.image('google/imagen4'),
                getCost: () => {
                    return 0.038 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.038 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '1x1'],
                resolutions: ['1K', '2K'],
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i'],
        supportsEdit: false,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'google/imagen4-fast': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: wavespeed.image('google/imagen4-fast'),
                getCost: () => {
                    return 0.018 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.018 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['16x9', '9x16', '4x3', '3x4', '1x1'],
                resolutions: ['1K', '2K'],
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i'],
        supportsEdit: false,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};